/* DemoPool lead forms (free sample, waitlist) — submit without leaving the page. 12.10.2026
 * Markup: <form data-lead-ajax> (Shopify {% form 'customer' %}) with
 *   <template data-lead-tpl> = success state (snippets/dp-lead-done.liquid)
 *   [data-lead-msg] slot holding the opt-in label and <p data-lead-err> (same grid cell, so an error never moves the layout)
 * Shopify bot protection (hCaptcha) binds the form on first focus and later calls form.submit() with its token.
 * It reads form.submit at bind time, so we replace form.submit here (defer script, before any focus):
 * the captcha path then lands in send() with the token already in the form. Without captcha, our submit
 * listener sends it directly. If Shopify still answers with /challenge, we fall back to a normal submit. */
// 19.10.2026: remember which list a free sample was asked for (localStorage dp_sample = {h: handle, t: ms}), so the
// double opt-in landing (snippets/dp-subscribe.liquid) can say "Your 10 free <list> are on the way" in this browser.
// Runs for AJAX and plain submits alike; storage errors (private mode) are ignored.
document.addEventListener('submit', e => {
  const f = e.target, tags = f && f.querySelector && f.querySelector('input[name="contact[tags]"]');
  if (!tags || !/(^|,)\s*sample-request\s*(,|$)/.test(tags.value)) return;
  const h = tags.value.split(',').map(t => t.trim().toLowerCase()).find(t => /^sample-/.test(t) && !/^sample-(request|exit|fu\d)/.test(t));
  if (!h) return;
  // 21.10.2026 owner: one free sample per week is a real block now. The second request in this browser within 7 days
  // (another list, or the same list under another email) is stopped HERE, in the capture phase, before Shopify's captcha
  // and the AJAX sender see it: no customer post, so no tags, no Flow run, no $0 order. The popup (dialog.dplim) opens instead.
  // Same list + same email is let through: Shopify adds no new tag, so Flow sends nothing twice (lost inbox, resend confirm).
  // Server side the same rule lives in both Flow workflows (Run code: last order tagged free-sample < 7 days -> ok = no).
  const WEEK = 7 * 864e5, now = Date.now(), key = h.slice(7);
  const inp = f.querySelector('input[type=email]'), em = inp ? inp.value.trim().toLowerCase() : '';
  if (!em || (inp && !inp.checkValidity())) return; // invalid email: the form's own check answers
  let prev = null; try { prev = JSON.parse(localStorage.getItem('dp_sample') || 'null'); } catch (_) {}
  if (prev && prev.h && now - prev.t < WEEK && !(prev.h === key && prev.e === em)) {
    e.preventDefault(); e.stopImmediatePropagation();
    f.dataset.sampleLimit = new Date(prev.t + WEEK).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    window.dispatchEvent(new CustomEvent('dp:sample-limit', { detail: { form: f } }));
    return;
  }
  delete f.dataset.sampleLimit;
  try { localStorage.setItem('dp_sample', JSON.stringify({ h: key, t: prev && prev.h === key && prev.e === em ? prev.t : now, e: em })); } catch (_) {}
}, true);
(() => {
  const forms = [...document.querySelectorAll('form[data-lead-ajax]')];
  if (!forms.length || !window.fetch || !window.DOMParser || !window.FormData) return;
  const nativeSubmit = HTMLFormElement.prototype.submit;
  const busy = new WeakSet(), saved = new WeakMap();

  const MSG = {
    invalid: "That email doesn't look right. Check it and try again.",
    blank: 'Pop your email in first.',
    offline: "Can't reach the store right now. Check your connection and try again.",
    generic: 'Something went wrong on our side. Try again in a minute.'
  };
  const pick = t => !t ? MSG.generic : /blank/i.test(t) ? MSG.blank : /invalid|format/i.test(t) ? MSG.invalid : t;

  const lock = f => { if (!f.style.height) f.style.height = f.offsetHeight + 'px'; };
  const unlock = f => { f.style.height = ''; };

  function fail(f, text) {
    const err = f.querySelector('[data-lead-err]'), slot = f.querySelector('[data-lead-msg]'), inp = f.querySelector('input[type=email]');
    f.classList.remove('is-busy'); f.removeAttribute('aria-busy');
    const btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = false;
    if (inp) inp.setAttribute('aria-invalid', 'true');
    if (err) { err.textContent = text; err.hidden = false; if (slot) slot.classList.add('has-err'); }
    unlock(f);
  }

  function clearErr(f) {
    const err = f.querySelector('[data-lead-err]'), slot = f.querySelector('[data-lead-msg]'), inp = f.querySelector('input[type=email]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (slot) slot.classList.remove('has-err');
    if (inp) inp.removeAttribute('aria-invalid');
  }

  // 19.10.2026 owner pick (variant B), 21.10 real block: the 7-day limit opens a popup over the page; nothing is sent, the form
  // stays as it was (email cleared), so nothing in the card turns into a wall of text. Markup: [data-lim] in snippets/dp-lead-done.liquid.
  function limitPopup(f, tpl) {
    const src = tpl.content.querySelector('[data-lim]'); if (!src) return false;
    const body = src.cloneNode(true); body.hidden = false;
    const d = body.querySelector('[data-lim-date]'); if (d) d.textContent = f.dataset.sampleLimit;
    const dlg = document.createElement('dialog');
    dlg.className = 'dplim'; dlg.setAttribute('aria-labelledby', 'dplim-h'); dlg.appendChild(body);
    document.body.appendChild(dlg);
    const close = () => { if (dlg.open) dlg.close(); };
    dlg.addEventListener('close', () => { dlg.remove(); const inp = f.querySelector('input[type=email]'); if (inp) inp.focus({ preventScroll: true }); });
    dlg.addEventListener('click', e => { if (e.target === dlg || e.target.closest('[data-lim-close]')) close(); }); // backdrop, x, "close"
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    const cta = body.querySelector('.dplim__cta'); if (cta) cta.focus({ preventScroll: true });
    try { window.dispatchEvent(new CustomEvent('dp:lead', { detail: { form: f.id, limit: true } })); } catch (_) {}
    return true;
  }

  // 21.10.2026: the blocked request never reaches send(); the capture listener above fires dp:sample-limit instead.
  window.addEventListener('dp:sample-limit', e => {
    const f = e.detail && e.detail.form; if (!f) return;
    const tpl = f.querySelector('template[data-lead-tpl]'); if (!tpl) return;
    const inp = f.querySelector('input[type=email]'); if (inp) inp.value = '';
    limitPopup(f, tpl);
  });

  function done(f) {
    const tpl = f.querySelector('template[data-lead-tpl]'); if (!tpl) return;
    lock(f);
    const kids = [...f.childNodes]; saved.set(f, kids);
    kids.forEach(n => n.remove());
    f.appendChild(tpl.content.cloneNode(true));
    f.appendChild(tpl); // keep the template for "use another email"
    f.classList.remove('is-busy'); f.removeAttribute('aria-busy'); f.classList.add('is-done');
    if (f.querySelector('.ldone__dl')) unlock(f); // taller than the form it replaces: let it grow
    const box = f.querySelector('[data-lead-done]');
    if (box) box.focus({ preventScroll: true });
    const again = f.querySelector('[data-lead-again]');
    if (again) again.addEventListener('click', () => reset(f));
    try { window.dispatchEvent(new CustomEvent('dp:lead', { detail: { form: f.id } })); } catch (_) {}
  }

  function reset(f) {
    const kids = saved.get(f); if (!kids) return;
    const tpl = f.querySelector('template[data-lead-tpl]');
    [...f.childNodes].forEach(n => n.remove());
    kids.forEach(n => f.appendChild(n));
    if (tpl && !f.contains(tpl)) f.appendChild(tpl);
    f.classList.remove('is-done');
    const btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = false;
    const inp = f.querySelector('input[type=email]');
    if (inp) { inp.value = ''; inp.focus({ preventScroll: true }); }
    unlock(f);
  }

  async function send(f) {
    if (busy.has(f) || f.classList.contains('is-done')) return;
    const inp = f.querySelector('input[type=email]');
    if (inp && !inp.checkValidity()) { fail(f, inp.value ? MSG.invalid : MSG.blank); return; }
    busy.add(f); clearErr(f); lock(f);
    f.classList.add('is-busy'); f.setAttribute('aria-busy', 'true');
    const btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    try {
      const r = await fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin', redirect: 'follow' });
      const url = r.url || '';
      if (/\/challenge(\b|\/|\?|$)/.test(url)) { busy.delete(f); nativeSubmit.call(f); return; } // visible captcha: let the browser show it
      const ok = /[?&]customer_posted=true/.test(url);
      let twin = null;
      if (!ok) {
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        twin = f.id ? doc.getElementById(f.id) : null;
      }
      if (ok || (twin && twin.querySelector('[data-lead-done]'))) done(f);
      else { const e = twin && twin.querySelector('.errors'); fail(f, pick(e && e.textContent.replace(/\s+/g, ' ').trim())); }
    } catch (_) {
      fail(f, MSG.offline);
    } finally {
      busy.delete(f);
    }
  }

  forms.forEach(f => {
    try { f.submit = () => send(f); } catch (_) {}
    f.setAttribute('novalidate', ''); // we show validation in-form instead of the browser bubble
    f.addEventListener('input', () => clearErr(f));
    // invalid email: answer in-form right away and keep the captcha from running for nothing
    f.addEventListener('submit', e => {
      const inp = f.querySelector('input[type=email]');
      if (inp && !inp.checkValidity()) { e.preventDefault(); e.stopImmediatePropagation(); fail(f, inp.value ? MSG.invalid : MSG.blank); inp.focus({ preventScroll: true }); }
    });
  });

  // Bubble phase on document: runs after Shopify's own listeners. If captcha took the event, it calls f.submit() later.
  document.addEventListener('submit', e => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.hasAttribute('data-lead-ajax') || e.defaultPrevented) return;
    e.preventDefault(); send(f);
  });
})();

// 19.10.2026: back from the popup's /discount/SAMPLE10 link -> say once that 10% off is on (Shopify sets the
// discount_code cookie). Shown once per browser session; no storage -> shown at most on this page view.
(() => {
  if (!/(?:^|;\s*)discount_code=SAMPLE10(?:;|$)/i.test(document.cookie)) return;
  try { if (sessionStorage.getItem('dp_s10')) return; sessionStorage.setItem('dp_s10', '1'); } catch (_) {}
  const t = document.createElement('div');
  t.className = 'dplim-toast'; t.setAttribute('role', 'status');
  t.innerHTML = '<i aria-hidden="true">&#10003;</i><span><b>10% off is on.</b> It\u2019s in your cart and comes off at checkout. Just pick a list.</span><button type="button" aria-label="Dismiss">&times;</button>';
  const bye = () => { t.classList.add('is-out'); setTimeout(() => t.remove(), 300); };
  t.querySelector('button').addEventListener('click', bye);
  const go = () => {
    document.body.appendChild(t); setTimeout(bye, 9000);
    const pick = document.getElementById('pick'); // back from the popup CTA: straight to the list picker
    if (pick && !location.hash) setTimeout(() => pick.scrollIntoView({ behavior: 'smooth', block: 'start' }), 250);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();
